define.alias("shared/components/shared/post/profile-selector", "preview-grid/components/shared/post/profile-selector/index");